import { createMuiTheme } from "@material-ui/core/styles";

// Create a theme instance.
const outerTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#0069d9"
    },
    secondary: {
      main: "#0069d9"
    }
  }
})



// eslint-disable-next-line no-unused-vars
const outerTheme1 = createMuiTheme({
  palette: {
    primary: {
      main: "#f00"
    },
    secondary: {
      main: "#0069d9"
    }
  },
  typography: {
    fontFamily: "Comic Sans MS",
    body2: {
      fontFamily: "Times New Roman",
      fontSize: "1.1rem"
    }
  },
  shape: {
    borderRadius: 2
  },
  spacing: 2,
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: "none",
        padding:0,
      }
    },
    MuiInputLabel: {
      root: {
        backgroundColor: "yellow"
      }
    },
    MuiTextField: {
      root: {}
    },
    MuiButton: {
      root: {
        textTransform: "none",
        padding: "15px"
      },
      fullWidth: {
        maxWidth: "100%"
      }
    },
    // eslint-disable-next-line no-dupe-keys
    MuiFilledInput:{
      root:{
        padding:0,
        backgroundColor:"yellow"
      }
    },
    MuiAutocomplete:{
      Root:{
        padding:0
      }
    }

  },
  props: {
    MuiButton: {
      disableRipple: true,
      variant: "contained",
      color: "primary"
    },
    MuiCheckbox: {
      disableRipple: true
    },
    MuiTextField: {
      variant: "filled",
      InputLabelProps: {
        shrink: true
      }
    },
    MuiPaper: {
      elevation: 12
    },
    MuiCard: {
      elevation: 2
    },
  }
});

export default outerTheme




/*
const theme = createMuiTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "green"
        },
        "&:hover $notchedOutline": {
          borderColor: "red"
        },
        "&$focused $notchedOutline": {
          borderColor: "purple"
        },
        "&&& $input": {
          padding: "1px"
        }
      }
    }
  }
});
*/